import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { DisplayDateFormat } from '@northfork/basics'
import { ToastService } from '@northfork/ng-basics'
import {
  MMFAccountCharacteristics,
  MMFCharacteristics,
  MMFData,
  MMFDividendCalendarTypes,
} from '../../../models/mmf-settings.model'
import { DistributionsService } from '../../../services/distributions.service'

@Component({
  selector: 'hs-add-mmf-calendar',
  templateUrl: './add-mmf-calendar.component.html',
  styleUrls: ['./add-mmf-calendar.component.scss'],
})
export class AddMmfCalendarComponent implements OnInit {
  existingMmfAccountData: MMFAccountCharacteristics[] = []
  mmfDividendCalendarTypes: MMFDividendCalendarTypes[] = []
  dateFormat = DisplayDateFormat
  mmfForm: FormGroup = new FormGroup({})
  dateControl = new FormControl('')
  duplicateCalendar = false
  isSavingCalendar = false

  @Input() mmfData?: MMFData

  constructor(
    readonly activeModal: NgbActiveModal,
    public formBuilder: FormBuilder,
    public toastService: ToastService,
    private readonly distributionsService: DistributionsService,
  ) {}

  ngOnInit(): void {
    if (this.mmfData) {
      this.mmfDividendCalendarTypes = this.mmfData.mmfDividendCalendarTypes
      this.existingMmfAccountData =
        this.mmfData.existingMmfData.length > 0
          ? this.mmfData.existingMmfData
          : []
      this.mmfForm = this.formBuilder.group({
        mmfDividendCalendarTypes: [
          this.mmfDividendCalendarTypes[0],
          Validators.required,
        ],
        startDate: [Validators.required],
      })

      this.mmfForm.markAllAsTouched()
    }
  }

  saveCalendar() {
    this.duplicateCalendar = false
    const calendar = (
      this.mmfForm.get('mmfDividendCalendarTypes')
        ?.value as MMFDividendCalendarTypes
    )?.name
    const date = this.mmfForm.get('startDate')?.value
    this.existingMmfAccountData.forEach(mmf => {
      if (mmf.dividendCalendar == calendar && mmf.beginDate == date) {
        this.duplicateCalendar = true
      }
    })
    if (!this.duplicateCalendar) {
      this.addCalendar(calendar, date)
    }
  }

  addCalendar(calendar: string, date: string) {
    this.isSavingCalendar = true
    const newCalendar = {
      mmfCharacteristicUpdates: [
        {
          accountId: this.mmfData?.accountId,
          beginDate: date,
          securityId: this.mmfData?.securityId,
          paysOnLiquidation: this.mmfData?.paysOnLiquidation,
          dividendCalendar: calendar,
        },
      ],
    } as MMFCharacteristics
    this.distributionsService.updateMmfCharacteristics(newCalendar).subscribe(
      () => {
        this.isSavingCalendar = false
        this.toastService.success('Calendar saved successfully')
        this.activeModal.close(true)
      },
      () => {
        this.toastService.error('Error saving calendar')
        this.isSavingCalendar = false
      },
    )
  }
}
